import { Link } from 'react-router-dom';
import { useEffect, useState } from "react";
import { UserDetailsApi, BookingDetailsApi } from "../services/Api";
import { isAuthenticated } from "../services/Auth";
import { Navigate } from "react-router-dom";
export default function BookingDetails() {

    const [user, setUser] = useState({ fullName: "", email: "", localId: "" });
    const [booking, setBooking] = useState();

    useEffect(() => {
        if (isAuthenticated()) {
            UserDetailsApi().then((response) => {
                setUser(values => ({
                    ...values,
                    fullName: response.data.users[0].displayName,
                    email: response.data.users[0].email,
                    localId: response.data.users[0].localId
                }))
            })
        }
    }, [])


    useEffect(() => {
        if (isAuthenticated() && user.localId) {
            BookingDetailsApi(user.localId).then((response) => {
                setBooking(response.data.booking)
            })
        }
    }, [user.localId])

    if (!isAuthenticated()) {
        //redirect user to login
        return <Navigate to="/login" />
    }


    return (booking &&
        <>
            <div className="container-fluid p-2">
                <h2 className="mt-5 text-center">You placed <b>{booking.length}</b> bookings</h2>
                {booking.map((bookingPart) =>
                (
                    <div className='m-lg-5' key={bookingPart._id}>
                        <div className='m-lg-5'>
                            <div className='m-sm-5 border border-5 p-3'>
                                <h4 className='text-center text-decoration-underline m-1'>Booking ID #{bookingPart._id}</h4>
                                <div><span className='fw-medium'>Booking Status : </span>{bookingPart.status}</div>
                                <div><span className='fw-medium'>Name : </span>{bookingPart.fullName}</div>
                                <div><span className='fw-medium'>Address : </span>{bookingPart.address}</div>
                                <div><span className='fw-medium'>Phone Number : </span>{bookingPart.pno}</div>
                                <div><span className='fw-medium'>Email Address : </span>{bookingPart.email}</div>
                                <div><span className='fw-medium'>Date : </span>{bookingPart.createdAt}</div>
                                <div><span className='fw-medium'>Total Amount : </span>Rs. {bookingPart.amount}</div>
                                <h5 className='text-center text-decoration-underline m-1'>Booking Room Varient(s)</h5>
                                <div className="booking-slot-item my-1">
                                    {bookingPart.bookingSlotItems && bookingPart.bookingSlotItems.map(item => (
                                        <div key={item.room._id}>
                                            <hr />
                                            <div className="bookingSlot-item">
                                                <div className="row">
                                                    <div className="col-6 col-lg-3 text-center">
                                                        <Link to={"/room/" + item.room._id}>
                                                            <img src={item.room.images[0].image} alt={item.room.name} height="110" width="140" />
                                                        </Link>
                                                    </div>

                                                    <div className='col-6 col-lg-9'>
                                                        <div className="row d-flex flex-column flex-lg-row justify-content-center align-items-center">
                                                            <h6 className="col text-center m-2">
                                                                <Link className='text-black' to={"/room/" + item.room._id} >{item.room.name}</Link>
                                                            </h6>

                                                            <div className="col text-center m-2">
                                                                <div>
                                                                    <h6>CheckIn</h6>
                                                                    <h6 className='fw-bolder'>{item.checkIn}</h6>
                                                                </div>
                                                                <hr />
                                                                <div>
                                                                    <h6>Days</h6>
                                                                    <h6 className='fw-bolder'>{item.days}</h6>
                                                                </div>
                                                            </div>

                                                            <div className="col text-center m-2">
                                                                <h6>Rooms</h6>
                                                                <h6>{item.qty}</h6>
                                                            </div>

                                                            <div className="col text-center m-3">
                                                                <h6>Varient Total</h6>
                                                                <h5>Rs. {item.room.price * item.days * item.qty}</h5>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    ))}

                                </div>
                                <hr />
                            </div>
                        </div>
                    </div>)
                )
                }
            </div>

        </>
    )
}